import { LOGIN_CONTENT } from './login';

export default LOGIN_CONTENT;
